<div>
  <MainHeader></MainHeader>
  <MainBody></MainBody>
  <MainGrid></MainGrid>
  <MainFooter></MainFooter>
</div>
